import { CSSProperties } from 'react';
import { View, ViewProps } from '@shared/components/View';
import classNames from './blinkingBackground.module.css';

interface BlinkingBackgroundProps extends ViewProps {
  from?: string;
  to: string;
}

/*
    This component changes background colors between from and to.
    If "from" is not set, it will only show "to".
*/
export function BlinkingBackground({
  from,
  to,
  className,
  style,
  ...viewProps
}: BlinkingBackgroundProps) {
  const blinkClass = !!from && classNames.blinkBackground;
  const blinkStyle = {
    ...style,
    backgroundColor: to,
    '--blink-from': from,
    '--blink-to': to,
  } as CSSProperties;

  return <View {...viewProps} className={[blinkClass, className]} style={blinkStyle} />;
}

interface BlinkingOpacityProps extends ViewProps {
  disabled: boolean;
}

export function BlinkingOpacity({ disabled, className, ...viewProps }: BlinkingOpacityProps) {
  return <View {...viewProps} className={[!disabled && classNames.blinkOpacity, className]} />;
}
